import './style.scss'
import { useContext, useEffect, useState } from 'react'
import utility from 'src/utils/utility'
import ApiContext from 'src/provider/API/call-service'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { useNavigate } from 'react-router-dom'
import { AbsoluteContainer, AppLink, AppSpan, AppText, Button, CustomContainer, FlexColumn, FlexRow, Form, FormGroup, GridContainer, Icon, RemeberMeContainer, ScreenContainer } from 'src/style'
import { BiCheck } from 'react-icons/bi'
import { BsEyeSlash, BsEye } from 'react-icons/bs'
import { ForgotPassword, OtpVerification } from 'src/component'
import { Features } from 'src/model'

export const SignInD3: React.FC = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {info: {institutionData}} = useContext(AppInfoContext)
    const [input, setInput] = useState({username: '', password: '', otp: ''})
    const [isRemember, setIsRemember] = useState(localStorage.getItem('isRememberMe') || false)
    const [showPassword, setShowPassword] = useState(false)
    const [view, setView] = useState('')
    const [appLogo, setAppLogo] = useState('')

    useEffect(() => {
        if (institutionData) setAppLogo(institutionData.logo)
    }, [institutionData?.logo])
    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    function handleRememberMe () {
        const rememberMe = isRemember ? '' : 'true'
        localStorage.setItem('isRememberMe', rememberMe)
        setIsRemember(!isRemember)
    }

    async function handleSubmit(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        const response = await API.login(input)
        if (response) {
            setInput({...input, otp: ''})
            setView('2fa-otp')
        }
        else setInput({username: '', password: '', otp: ''})
    }

    async function handleOtpAuth() {
        const response = await API.authenticateLoginOtp(input)
        if (response) {
            setView('')
            navigate('/dashboard/home')
        }
        else setInput({...input, otp: ''})
    }

    return (
        <>
            <ScreenContainer 
                padding='0'
                className='d2-screen-container-bg'
            >
                <GridContainer height='100' hUnit='%'>
                    <CustomContainer
                        width='103.9' height='57' radius='2'
                        leftPadding='36.2'
                        className='d2-login-container'
                    >
                        <CustomContainer
                            height='100' hUnit='%' 
                            className='d2-login-container-bg'
                        >
                            <FlexColumn 
                                height='100' hUnit='%' justifyContent='flex-end' 
                                alignItems='flex-start' padding='5'
                            >
                                <AppText 
                                    textSize='4.5' fontWeight='800' color='#ffffff' fontFamily='Gilmer-Bold'
                                    style={{lineHeight: '5.5rem'}}
                                >
                                    Welcome to {institutionData.name}
                                </AppText>
                            </FlexColumn>
                        </CustomContainer>
                        <AbsoluteContainer top='0' left='0' height='full' className='signin-input-container'>
                            <GridContainer 
                                padding='4.5' height='100' hUnit='%' width='36.2' 
                                bgColor='rgba(23, 23, 23, 0.35)'
                                style={{backdropFilter: 'blur(12px)'}}
                                className='signin-input-wrapper'
                            >
                                <CustomContainer>
                                    <CustomContainer width='15.4' height='3.5' bottomMargin='2'>
                                        {appLogo ? <Icon src={appLogo} noResize className='app-logo-icon' /> : null}
                                    </CustomContainer>
                                    <AppText textSize='2.3' color='#ffffff' fontWeight='700' fontFamily='Gilmer-Bold'>Welcome back!</AppText>
                                    <AppSpan color='#ffffff' textSize='1.2'>Sign in to Continue</AppSpan>

                                    <Form topMargin='3' onSubmit={handleSubmit}>
                                        <FormGroup 
                                            color='#ffffff' bgColor='#ffffff' textSize='1.3' 
                                            fontWeight='500' height='3.5' titleSize='1.1'
                                            radius='0.628' bottomMargin='1.2'
                                            noFocusBorder={true}
                                        >
                                            <label>Username</label>
                                            <input 
                                                placeholder="Username or Account Number" 
                                                name='username'
                                                value={input.username}
                                                onChange={handleInput}
                                                autoComplete="off"
                                                required
                                            />
                                        </FormGroup>
                                        <FormGroup
                                            color='#ffffff' bgColor='#ffffff' textSize='1.3'
                                            fontWeight='500' height='3.5' titleSize='1.1'
                                            radius='0.628' bottomMargin='1.2'
                                            noFocusBorder={true}
                                        >
                                            <label>Password</label>
                                            <input 
                                                placeholder="XXXXXXX" 
                                                name='password'
                                                type={showPassword ? 'text' : 'password'}
                                                value={input.password}
                                                onChange={handleInput}
                                                autoComplete="off"
                                                required
                                            />
                                            { !showPassword ?
                                                <AbsoluteContainer bottom='0.8' right='1'>
                                                    <AppSpan 
                                                        color='rgba(0, 0, 0, 0.5)' textSize='1.5' cursor='pointer'
                                                        onClick={() => setShowPassword(true)}
                                                    >
                                                        <BsEyeSlash/>
                                                    </AppSpan>
                                                </AbsoluteContainer>
                                                :
                                                <AbsoluteContainer bottom='0.8' right='1'>
                                                    <AppSpan 
                                                        color='rgba(0, 0, 0, 0.5)' textSize='1.5' cursor='pointer'
                                                        onClick={() => setShowPassword(false)}
                                                    >
                                                        <BsEye/>
                                                    </AppSpan>
                                                </AbsoluteContainer>
                                            }
                                        </FormGroup>
                                        <AppSpan 
                                            hoverColor='#0A756F' color='#ffffff' textSize='1.1'
                                            className='forget-password' cursor='pointer'
                                            onClick={() => setView('forgot-password')}
                                        >
                                            Forgot Password
                                        </AppSpan>
                                        <Button 
                                            width='100' sizeUnit='%' topMargin='1.5' 
                                            borderColor='#0D968F' hoverBgColor='#fff' 
                                            hoverColor='#0D968F' height='3.5'
                                        >
                                            Login
                                        </Button>
                                    </Form>
                                    { (institutionData.featureIDs?.includes(Features.NEW_CUSTOMER_ONBOARDING) || institutionData.featureIDs?.includes(Features.EXISTING_CUSTOMER_ONBOARDING)) &&
                                        <AppText topMargin='2.5' align='center'>
                                            <AppLink 
                                                textSize='1.1' color='#ffffff'
                                                decoration='none' hoverColor='#0A756F'
                                                onClick={() => navigate('/onboarding/type')}
                                            >
                                                Set Up Internet Banking
                                            </AppLink>
                                        </AppText>
                                    }
                                </CustomContainer>
                            </GridContainer>
                        </AbsoluteContainer>
                    </CustomContainer>
                </GridContainer>
            </ScreenContainer>
            { view === 'forgot-password' &&
                <ForgotPassword
                    close={() => setView('')} 
                />
            }
            { view === '2fa-otp' &&
                <OtpVerification 
                    close={() => setView('')}
                    formData={input}
                    resendOtpMethod={() => API.login(input)}
                    handleInput={handleInput}
                    next={handleOtpAuth}
                />
            }
        </>
    )
}